import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderSlot as _renderSlot, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-9347c238"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vtl vtl-card" }
const _hoisted_2 = {
  key: 0,
  class: "vtl-card-title"
}
const _hoisted_3 = { class: "vtl-card-body" }
const _hoisted_4 = { class: "vtl-row" }
const _hoisted_5 = {
  key: 0,
  class: "vtl-loading-mask"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vtl-loading-content" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"white"} }, "Loading...")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "vtl-thead" }
const _hoisted_9 = { class: "vtl-thead-tr" }
const _hoisted_10 = {
  key: 0,
  class: "vtl-thead-th vtl-checkbox-th"
}
const _hoisted_11 = ["indeterminate"]
const _hoisted_12 = ["onClick", "innerHTML"]
const _hoisted_13 = ["set"]
const _hoisted_14 = {
  key: 0,
  class: "vtl-tbody-tr vtl-group-tr"
}
const _hoisted_15 = ["colspan"]
const _hoisted_16 = { class: "flex" }
const _hoisted_17 = {
  key: 0,
  class: "animation"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = ["name", "onClick"]
const _hoisted_21 = {
  key: 0,
  class: "vtl-tbody-td"
}
const _hoisted_22 = ["value", "onClick"]
const _hoisted_23 = ["onMouseover", "onMouseleave"]
const _hoisted_24 = ["innerHTML"]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = ["set"]
const _hoisted_29 = {
  key: 0,
  class: "vtl-tbody-tr vtl-group-tr"
}
const _hoisted_30 = ["colspan"]
const _hoisted_31 = { class: "flex" }
const _hoisted_32 = {
  key: 0,
  class: "animation"
}
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = ["name", "onClick"]
const _hoisted_36 = {
  key: 0,
  class: "vtl-tbody-td"
}
const _hoisted_37 = ["value", "onClick"]
const _hoisted_38 = ["onMouseover", "onMouseleave"]
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = {
  key: 0,
  class: "vtl-paging vtl-row"
}
const _hoisted_44 = { class: "vtl-paging-info col-sm-12 col-md-4" }
const _hoisted_45 = {
  role: "status",
  "aria-live": "polite"
}
const _hoisted_46 = { class: "vtl-paging-change-div col-sm-12 col-md-4" }
const _hoisted_47 = { class: "vtl-paging-count-label" }
const _hoisted_48 = ["value"]
const _hoisted_49 = { class: "vtl-paging-page-label" }
const _hoisted_50 = ["value"]
const _hoisted_51 = { class: "vtl-paging-pagination-div col-sm-12 col-md-4" }
const _hoisted_52 = { class: "dataTables_paginate" }
const _hoisted_53 = { class: "vtl-paging-pagination-ul vtl-pagination" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "«", -1))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "First", -1))
const _hoisted_56 = [
  _hoisted_54,
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "<", -1))
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Prev", -1))
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = ["onClick"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, ">", -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Next", -1))
const _hoisted_63 = [
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "»", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Last", -1))
const _hoisted_66 = [
  _hoisted_64,
  _hoisted_65
]
const _hoisted_67 = {
  key: 1,
  class: "vtl-row"
}
const _hoisted_68 = { class: "vtl-empty-msg col-sm-12 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: _normalizeClass(["col-sm-12", {
            'fixed-first-column': _ctx.isFixedFirstColumn,
            'fixed-first-second-column': _ctx.isFixedFirstColumn && _ctx.hasCheckbox,
          }])
        }, [
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
            : _createCommentVNode("", true),
          _createElementVNode("table", {
            class: "vtl-table vtl-table-hover vtl-table-bordered vtl-table-responsive vtl-table-responsive-sm",
            ref: "localTable",
            style: _normalizeStyle('max-height: ' + _ctx.maxHeight + 'px;')
          }, [
            _createElementVNode("thead", _hoisted_8, [
              _createElementVNode("tr", _hoisted_9, [
                (_ctx.hasCheckbox)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_10, [
                      _createElementVNode("div", null, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          class: "vtl-thead-checkbox",
                          indeterminate: _ctx.setting.isIndeterminate,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.setting.isCheckAll) = $event))
                        }, null, 8, _hoisted_11), [
                          [_vModelCheckbox, _ctx.setting.isCheckAll]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.columns as Array<any>), (col, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    class: _normalizeClass(["vtl-thead-th", col.headerClasses]),
                    key: index,
                    style: _normalizeStyle(
                    Object.assign(
                      {
                        width: col.width ? col.width : 'auto',
                      },
                      col.headerStyles
                    )
                  )
                  }, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["vtl-thead-column", {
                      'vtl-sortable': col.sortable,
                      'vtl-both': col.sortable,
                      'vtl-asc': _ctx.setting.order === col.field && _ctx.setting.sort === 'asc',
                      'vtl-desc': _ctx.setting.order === col.field && _ctx.setting.sort === 'desc',
                    }]),
                      onClick: _withModifiers(($event: any) => (col.sortable ? _ctx.doSort(col.field) : false), ["prevent"]),
                      innerHTML: col.label
                    }, null, 10, _hoisted_12)
                  ], 6))
                }), 128))
              ])
            ]),
            (_ctx.rows.length > 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.isStaticMode)
                    ? (_openBlock(), _createElementBlock("tbody", {
                        key: 0,
                        class: "vtl-tbody",
                        set: (_ctx.templateRows = _ctx.groupingKey == '' ? [_ctx.localRows] : _ctx.localRows)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateRows, (rows, groupingIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: groupingIndex }, [
                            (_ctx.groupingKey != '')
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_14, [
                                  _createElementVNode("td", {
                                    colspan: _ctx.hasCheckbox ? _ctx.columns.length + 1 : _ctx.columns.length,
                                    class: "vtl-tbody-td vtl-group-td"
                                  }, [
                                    _createElementVNode("div", _hoisted_16, [
                                      (_ctx.hasGroupToggle)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            _createElementVNode("a", {
                                              ref_for: true,
                                              ref: (el) => (_ctx.toggleButtonRefs[groupingIndex] as any) = el,
                                              class: "cursor-pointer",
                                              onClick: _withModifiers(($event: any) => (_ctx.toggleGroup(groupingIndex.toString())), ["prevent"])
                                            }, "▼", 8, _hoisted_18)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: "ml-2",
                                        innerHTML: 
                            _ctx.groupingDisplay
                              ? _ctx.groupingDisplay(groupingIndex)
                              : groupingIndex
                          
                                      }, null, 8, _hoisted_19)
                                    ])
                                  ], 8, _hoisted_15)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows, (row, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: row[_ctx.setting.keyColumn] ? row[_ctx.setting.keyColumn] : i,
                                ref_for: true,
                                ref: 
                      (el) => {
                        if (!_ctx.groupingRowsRefs[groupingIndex]) {
                          _ctx.groupingRowsRefs[groupingIndex] = [];
                        }
                        _ctx.groupingRowsRefs[groupingIndex][i] = el;
                      }
                    ,
                                name: 'vtl-group-' + groupingIndex,
                                class: _normalizeClass(["vtl-tbody-tr", 
                      typeof _ctx.rowClasses === 'function' ? _ctx.rowClasses(row) : _ctx.rowClasses
                    ]),
                                onMouseenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.addHoverClassToTr && _ctx.addHoverClassToTr(...args))),
                                onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.removeHoverClassFromTr && _ctx.removeHoverClassFromTr(...args))),
                                onClick: ($event: any) => (_ctx.$emit('row-clicked', row))
                              }, [
                                (_ctx.hasCheckbox)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_21, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          class: "vtl-tbody-checkbox",
                                          ref_for: true,
                                          ref: 
                            (el) => {
                              (_ctx.rowCheckbox as Array<HTMLElement>).push(el);
                            }
                          ,
                                          value: row[_ctx.setting.keyColumn],
                                          onClick: ($event: any) => (_ctx.checked(row, $event))
                                        }, null, 8, _hoisted_22)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.columns as Array<any>), (col, j) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: j,
                                    class: _normalizeClass(["vtl-tbody-td", ['vtl-tbody-td' + j].concat(col.columnClasses)]),
                                    style: _normalizeStyle(col.columnStyles),
                                    onMouseover: ($event: any) => (_ctx.addVerticalHighlight(j)),
                                    onMouseleave: ($event: any) => (_ctx.removeVerticalHighlight(j))
                                  }, [
                                    (col.display)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          innerHTML: col.display(row)
                                        }, null, 8, _hoisted_24))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                          (_ctx.setting.isSlotMode && _ctx.slots[col.field])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                                _renderSlot(_ctx.$slots, col.field, { value: row }, undefined, true)
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(row[col.field]), 1))
                                        ]))
                                  ], 46, _hoisted_23))
                                }), 128))
                              ], 42, _hoisted_20))
                            }), 128))
                          ], 64))
                        }), 128))
                      ], 8, _hoisted_13))
                    : (_openBlock(), _createElementBlock("tbody", {
                        key: 1,
                        set: (_ctx.templateRows = _ctx.groupingKey == '' ? [_ctx.rows] : _ctx.groupingRows)
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templateRows, (rows, groupingIndex) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: groupingIndex }, [
                            (_ctx.groupingKey != '')
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_29, [
                                  _createElementVNode("td", {
                                    colspan: _ctx.hasCheckbox ? _ctx.columns.length + 1 : _ctx.columns.length,
                                    class: "vtl-tbody-td vtl-group-td"
                                  }, [
                                    _createElementVNode("div", _hoisted_31, [
                                      (_ctx.hasGroupToggle)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                            _createElementVNode("a", {
                                              ref_for: true,
                                              ref: (el) => (_ctx.toggleButtonRefs[groupingIndex] as any) = el,
                                              class: "cursor-pointer",
                                              onClick: _withModifiers(($event: any) => (_ctx.toggleGroup(groupingIndex.toString())), ["prevent"])
                                            }, "▼", 8, _hoisted_33)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("div", {
                                        class: "ml-2",
                                        innerHTML: 
                            _ctx.groupingDisplay
                              ? _ctx.groupingDisplay(groupingIndex)
                              : groupingIndex
                          
                                      }, null, 8, _hoisted_34)
                                    ])
                                  ], 8, _hoisted_30)
                                ]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows, (row, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                ref_for: true,
                                ref: 
                      (el) => {
                        if (!_ctx.groupingRowsRefs[groupingIndex]) {
                          _ctx.groupingRowsRefs[groupingIndex] = [];
                        }
                        _ctx.groupingRowsRefs[groupingIndex][i] = el;
                      }
                    ,
                                name: 'vtl-group-' + groupingIndex,
                                key: row[_ctx.setting.keyColumn] ? row[_ctx.setting.keyColumn] : i,
                                class: _normalizeClass(["vtl-tbody-tr", 
                      typeof _ctx.rowClasses === 'function' ? _ctx.rowClasses(row) : _ctx.rowClasses
                    ]),
                                onMouseenter: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addHoverClassToTr && _ctx.addHoverClassToTr(...args))),
                                onMouseleave: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.removeHoverClassFromTr && _ctx.removeHoverClassFromTr(...args))),
                                onClick: ($event: any) => (_ctx.$emit('row-clicked', row))
                              }, [
                                (_ctx.hasCheckbox)
                                  ? (_openBlock(), _createElementBlock("td", _hoisted_36, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                          type: "checkbox",
                                          class: "vtl-tbody-checkbox",
                                          ref_for: true,
                                          ref: (el) => (_ctx.rowCheckbox as Array<HTMLElement>).push(el),
                                          value: row[_ctx.setting.keyColumn],
                                          onClick: ($event: any) => (_ctx.checked(row, $event))
                                        }, null, 8, _hoisted_37)
                                      ])
                                    ]))
                                  : _createCommentVNode("", true),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.columns as Array<any>), (col, j) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: j,
                                    class: _normalizeClass(["vtl-tbody-td", ['vtl-tbody-td' + j].concat(col.columnClasses)]),
                                    style: _normalizeStyle(col.columnStyles),
                                    onMouseover: ($event: any) => (_ctx.addVerticalHighlight(j)),
                                    onMouseleave: ($event: any) => (_ctx.removeVerticalHighlight(j))
                                  }, [
                                    (col.display)
                                      ? (_openBlock(), _createElementBlock("div", {
                                          key: 0,
                                          innerHTML: col.display(row)
                                        }, null, 8, _hoisted_39))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                          (_ctx.setting.isSlotMode && _ctx.slots[col.field])
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                                _renderSlot(_ctx.$slots, col.field, { value: row }, undefined, true)
                                              ]))
                                            : (_openBlock(), _createElementBlock("span", _hoisted_42, _toDisplayString(row[col.field]), 1))
                                        ]))
                                  ], 46, _hoisted_38))
                                }), 128))
                              ], 42, _hoisted_35))
                            }), 128))
                          ], 64))
                        }), 128))
                      ], 8, _hoisted_28))
                ], 64))
              : _createCommentVNode("", true)
          ], 4)
        ], 2)
      ]),
      (_ctx.rows.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
            (!_ctx.setting.isHidePaging)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.stringFormat(_ctx.messages.pagingInfo, _ctx.setting.offset, _ctx.setting.limit, _ctx.total)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.messages.pageSizeChangeLabel), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "vtl-paging-count-dropdown",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.setting.pageSize) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.pageOptions as Array<pageOption>), (pageOption) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: pageOption.value,
                          key: pageOption.value
                        }, _toDisplayString(pageOption.text), 9, _hoisted_48))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.setting.pageSize]
                    ]),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.messages.gotoPageLabel), 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "vtl-paging-page-dropdown",
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.setting.page) = $event))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.maxPage, (n) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: n,
                          value: parseInt(n.toString())
                        }, _toDisplayString(n), 9, _hoisted_50))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.setting.page]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_51, [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("ul", _hoisted_53, [
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-first page-item", { disabled: _ctx.setting.page <= 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-first page-link cursor-pointer",
                            "aria-label": "Previous",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.setting.page = 1), ["prevent"]))
                          }, _hoisted_56)
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-prev page-item", { disabled: _ctx.setting.page <= 1 }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-prev page-link cursor-pointer",
                            "aria-label": "Previous",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args)), ["prevent"]))
                          }, _hoisted_59)
                        ], 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.setting.paging, (n) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-number page-item", { disabled: _ctx.setting.page === n }]),
                            key: n
                          }, [
                            _createElementVNode("a", {
                              class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-number page-link cursor-pointer",
                              onClick: _withModifiers(($event: any) => (_ctx.movePage(n)), ["prevent"])
                            }, _toDisplayString(n), 9, _hoisted_60)
                          ], 2))
                        }), 128)),
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-next page-item", { disabled: _ctx.setting.page >= _ctx.setting.maxPage }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-next page-link cursor-pointer",
                            "aria-label": "Next",
                            onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args)), ["prevent"]))
                          }, _hoisted_63)
                        ], 2),
                        _createElementVNode("li", {
                          class: _normalizeClass(["vtl-paging-pagination-page-li vtl-paging-pagination-page-li-last page-item", { disabled: _ctx.setting.page >= _ctx.setting.maxPage }])
                        }, [
                          _createElementVNode("a", {
                            class: "vtl-paging-pagination-page-link vtl-paging-pagination-page-link-last page-link cursor-pointer",
                            "aria-label": "Next",
                            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.setting.page = _ctx.setting.maxPage), ["prevent"]))
                          }, _hoisted_66)
                        ], 2)
                      ])
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_67, [
            _createElementVNode("div", _hoisted_68, _toDisplayString(_ctx.messages.noDataAvailable), 1)
          ]))
    ])
  ]))
}